// ========================================================
// LANGUAGE TRANSLATIONS
// (mostly just for translating Gravity Forms on the fly)
// ========================================================

const translate = () => {
	// Look for string translations in global window variable which reads
	// strings from backend plugin admin page.
	const translations = TRIMARK_VARS.translations;

	// Forms Inputs
	$('form input[placeholder], form input[type="button"], form input[type="submit"]').each((i, input) => {
		const $input = $(input);
		const type = $input.attr('type');

		// Submit or page buttons
		if (type === 'submit' || type === 'button') {
			const text = $input.val();
			if (translations.hasOwnProperty(text)) {
				$input.val(translations[text]);
			}
		}
		// All other inputs (with a placeholder value)
		else {
			const placeholder = $input.attr('placeholder');
			if (translations.hasOwnProperty(placeholder)) {
				$input.attr('placeholder', translations[placeholder]);
			}
		}
	});

	// Form Disclaimer
	$('.form-disclaimer').each((i, el) => {
		const $this = $(el);
		const translatedVal = translations.hasOwnProperty('{{FORM_DISCLAIMER}}') ? translations['{{FORM_DISCLAIMER}}'] : null;

		if (translatedVal) {
			$this.html(translatedVal);
		}
	});

	// Form Error Messages and Labels
	$('.gfield_validation_message, .gform_submission_error, .gfield_label, .gform-field-label').each((i, el) => {
		const $this = $(el);
		const text = $this.text();
		const translatedVal = translations.hasOwnProperty(text) ? translations[text] : null;

		if (translatedVal) {
			$this.text(translatedVal);
		}
	});
}

// Translate on document ready
window.addEventListener('DOMContentLoaded', () => {
	translate();
});

// Also translate when multi-step form pages are shown/hidden
$(document).on('gform_post_render', function (event, form_id, current_page) {
	translate();
});
